
<template>
  <div class="d-flex flex-column gap-5 align-items-center w-100 px-3 pb-3">
    <div style="height: 150px; overflow: hidden;" class="d-flex fondo-secundario align-items-center justify-content-center position-relative z-index-0 w-100 rounded-3">
      <!-- Imagen con filtro verde -->
      <img src="../assets/menuBackground.webp" alt="menu" class="img-fluid w-100 h-100 z-index-0" style="object-fit: cover;">

      <!-- Filtro verde -->
      <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(69, 69, 69, 0.5);"></div>

      <!-- Texto encima de la imagen -->
      <div class="text-center position-absolute w-100 z-index-0">
        <p class="text-white fs-1 mb-0 fw-bold">{{ $t('menu') }}</p>
      </div>
    </div>
    <div class="mx-5 container">
      <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-4">
        <!-- Carta adicional con el botón de + -->
        <div v-if="ManejarMenus" class="col card-hover-scale" @click="openModal">
          <div class="card rounded-4 border-0 sombra-sm d-flex flex-column align-items-center justify-content-center fondo-terciario texto-principal" style="height: 100%; cursor: pointer;">
            <div class="card-body text-center d-flex flex-column align-items-center justify-content-center" style="height: 100%;">
              <h3 class="texto-principal">+</h3>
              <p>{{ $t('añadirNuevoMenu') }}</p>
            </div>
          </div>
        </div>
        <!-- Mostrar las galerías -->
        <div class="col card-hover-scale" v-for="galeria in menus" :key="galeria.IdContenido">
          <a :href="galeria.RedirectionUrl" target="_blank" class="text-decoration-none">
            <div class="card rounded-4 border-0 sombra d-flex flex-column fondo-terciario texto-principal" style="height: 100%;">
              <img v-if="galeria.RedirectionUrl && !imagenError" :src="galeria.RedirectionUrl" alt="Beneficios" class="card-img-top rounded-top-4" style="width: 100%; max-height: 200px; object-fit: cover; object-position: top;" @error="imagenError = true">
              <div v-if="!galeria.RedirectionUrl || imagenError" class="d-flex justify-content-center align-items-center fondo-secundario card-img-top rounded-top-4" style="height: 200px;">
                <i class="bi bi-image fs-1 texto-secundario"></i>
              </div>
              <div class="card-body text-center">
                <p class="card-text fw-semibold">{{ galeria.Titulo }}</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
      <img src="../assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
    </div>

    <!-- Modal para agregar nueva galería -->
    <div v-if="showModal & ManejarMenus" class="modal-overlay">
      <div class="modal-container fondo-secundario sombra texto-principal">
        <h3>{{ $t('añadirNuevoMenu') }}</h3>
        <form @submit.prevent="submitForm">
          <div class="mb-3">
            <label for="titulo" class="form-label">{{ $t('titulo') }}</label>
            <input type="text" id="titulo" v-model="newMenu.Titulo" class="form-control sombra-sm" required />
          </div>
          <!-- Divider -->
          <div class="col-12 my-2" style="border-top: 1px solid #ddd; height: 1px"></div>
          <!-- Campo para subir archivo -->
          <div class="mb-3">
            <label for="archivo" class="form-label">{{ $t('archivo') }}</label>
            <input type="file" id="archivo" @change="handleFileUpload" class="form-control sombra-sm"/>
          </div>
          <div v-if="loadingFile" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
            <img src="../assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
          </div>
          
          <div class="d-flex flex-row gap-2">
            <button type="submit" class="btn btn-primary sombra-sm">{{ $t('agregar') }}</button>
            <button @click="closeModal" class="btn btn-secondary sombra-sm">{{ $t('cancelar') }}</button>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed, onMounted, ref } from 'vue';
  import { useStore } from "vuex";
  import { useRouter } from "vue-router";
  import api from '@/services/api';


export default {
  name: "MenuPage",
  setup() {
    const showModal = ref(false);
    const store = useStore();
    const user = computed(() => store.state.user);
    const router = useRouter();
    const ManejarMenus = ref(false);
    let imagenError = ref(false);
    const menus = ref([]);
    const loading = ref(false);
    const loadingFile = ref(false);
    const newMenu = ref({
      Titulo: "",
      Descripcion: "",
      ImagenUrl: "",
      LogoUrl: "",
      RedirectionUrl: "",
      Habilitado: true,
      FechaCreacion: "",
      ContenidoTipos: [{ IdContenido: "00000000-0000-0000-0000-000000000000", IdTipoContenido: "2d278dbd-63e0-4103-ab57-65f739719343" }]
    });
    
    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        if(user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation.permiso === 'Formularios') || user.value.email.some(emails => emails.email.includes('@goethe.edu.ar'))){
          console.log("Tiene Permiso")
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
        var permisoAComprobar = 'ManejarMenus'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
            ManejarMenus.value = true
        }
      }
    };
    // Función para manejar la carga de archivos
    const handleFileUpload = async (event) => {
      const file = event.target.files[0];
      if (file) {
        try {
          loadingFile.value = true;
          const archivoData = new FormData();
          archivoData.append('archivo', file); // Agrega el archivo

          const response = await api.post(`api/Archivos`, archivoData, {
            params: {
              hotlink: true,
            },
            headers: {
              'Content-Type': 'multipart/form-data', // Asegúrate de enviar el tipo de contenido correcto
            },
          });
          //console.log(response.data)
          // Suponiendo que la API devuelve la URL del archivo subido
          newMenu.value.RedirectionUrl = response.data.enlace; // Asigna la URL del archivo subido al campo ImagenUrl
          loadingFile.value = false;
        } catch (error) {
          console.error('Error al subir archivo:', error);
          loadingFile.value = false;
        }
      }
    };

    const openModal = () => {
      showModal.value = true;
    };

    const closeModal = () => {
      showModal.value = false;
    };

    const fetchMenu = async () => {
      try {
        loading.value = true;
        const response = await api.get(`api/Contenido/ByTipo`, {
          params: {
            tipo: 'Menu',
            searchTerm: null,
            page: 1,
          }
        });
        menus.value = response.data.Items;
        //console.log(menus.value)
        loading.value = false;
      } catch (error) {
        console.error('Error al obtener los menus:', error);
        loading.value = false;
      }
    };

    const submitForm = async () => {
      try {
        newMenu.value.IdContenido= "00000000-0000-0000-0000-000000000000",
        newMenu.value.Descripcion = null;
        newMenu.value.ImagenUrl = null;
        newMenu.value.FechaCreacion = new Date();
        newMenu.value.EsPublicoATodos = true;

        newMenu.value.ContenidoTipos = [
          {
            "IdContenido": "00000000-0000-0000-0000-000000000000",
            "IdTipoContenido": "a8f09580-484c-4512-bbc7-e3bcf98096c9"
          }
        ];
        await api.post(`api/Contenido`, newMenu.value);
        console.log('Menú agregado');
        fetchMenu(); // Actualizar la lista de galerías
        closeModal(); // Cerrar el modal
      } catch (error) {
        console.error('Error al agregar el Menú:', error);
      }
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      checkAuth();
      fetchMenu();
    });

    return {
      menus,
      showModal,
      newMenu,
      openModal,
      closeModal,
      submitForm,
      ManejarMenus,
      loading,
      imagenError,
      handleFileUpload,
      loadingFile,
    };
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  padding: 20px;
  border-radius: 8px;
  width: 400px;
}

.card-body h3 {
  font-size: 50px;
}
</style>
